import { API } from './API';

const DEFAULT_OPTIONS = {
  baseUrl: 'graphql',
};

export class OrgAPI extends API {
  constructor(options = {}) {
    super({ ...DEFAULT_OPTIONS, ...options });
  }

  get({
    id,
  }) {
    const query = `
      query Org {
        listOrgs {
          id
          name
          market
          roles {
            role_id
            org_id
            person_id
          }
        }
      }
    `;
    const data = {
      id,
    };
    return super.get({ query, data }).then(({ listOrgs }) => ({ data: listOrgs }));
  }

  findById(id) {
    const query = `
      query Org($id: ID!) {
        getOrg(id: $id) {
          id
          name
          market
          roles {
            role_id
            org_id
            person_id
          }
        }
      }
    `;
    const data = {
      id,
    };
    return super.get({ query, data }).then(({ getOrg }) => ({ data: getOrg }));
  }
}



// WEBPACK FOOTER //
// ./src/lib/api/OrgAPI.js